import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IAccount } from '../models/account.model';
import { AuthService } from '../auth/auth.service';
import { ProfileService } from '../auth/profile.service';
import { IDataArray, IRemoteReference } from '../models/data-array.model';
import { environment } from '../../environments/environment';

@Injectable()
export class AccountService {

    get headers(): HttpHeaders {
        let headers: HttpHeaders = new HttpHeaders();
        headers = this.auth.addAuthHttpHeaders(headers);
        headers = this.profile.addProfileHttpHeaders(headers);
        return headers;
    }

    constructor(
        private http: HttpClient,
        private auth: AuthService,
        private profile: ProfileService,
    ) { }

    getAll(): Observable<IDataArray<IAccount>> {
        let url: string = environment.apiEndpoint + '/accounts';
        return this.http.get<IDataArray<IAccount>>(url, { headers: this.headers });
    }

    getById(id: string): Observable<IAccount> {
        let url: string = environment.apiEndpoint + `/accounts/${id}`;
        return this.http.get<IAccount>(url, { headers: this.headers });
    }

    create(account: IAccount): Observable<IRemoteReference<IAccount>> {
        let url: string = environment.apiEndpoint + '/accounts';
        return this.http.post<IRemoteReference<IAccount>>(url, account, { headers: this.headers });
    }

    update(account: IAccount): Observable<void> {
        let url: string = environment.apiEndpoint + `/accounts/${account.id}`;
        return this.http.put<void>(url, account, { headers: this.headers });
    }

    delete(id: string): Observable<void> {
        let url: string = environment.apiEndpoint + `/accounts/${id}`;
        return this.http.delete<void>(url, { headers: this.headers });
    }
}
